import { DocumentEvaCompanyApparence, HTMLEntry } from "../../eva-company/domains/eva-company";

export enum ModelPDF {
  MODEL_1 = "MODEL_1",
  MODEL_2 = "MODEL_2",
}

export class OfferPdfConfig {
  contact_id = null;
  header_location = "";
  header_date = null;
  show_info_employee = true;
  show_info_project = true;
  show_info_offer = true;
  show_info_customer = true;
  footerHTML: string;
  apparence: DocumentEvaCompanyApparence = new DocumentEvaCompanyApparence();
  isOriginalApparence: boolean = true;
  displayQuotation: boolean = true;
  showDetailQuotationInRecap: boolean = false;
  recapAmountPageBreak: boolean = false;
  recapTablePageBreak: boolean = false;
  detailledQuotationPageBreak: boolean = false;
  outroPageBreak: boolean = false;
  closingPageBreak: boolean = false;
  displaySignature: boolean = false;
  displayQuotationAsAnnex: boolean = false;
  isShowsArticleNumber: boolean = false;
  isShowsDiscountValue: boolean = false;
  isShowsSellingPriceUnit: boolean = false;
  isShowsSellingPriceTotal: boolean = true;
  isShowsQuantity: boolean = false;
  isShowsArticlePrices: boolean = false;
  showRecap: boolean = false;
  showRecapFirst: boolean = false;
  logoSize: string = "80";
  pdfModel: string = "MODEL_1";
  annexes: HTMLEntry[] = [];
  title = "";
  reference = "";
  headerHTML = "";
  outro_offerHTML = "";
  closing_textHTML = "";
  recap_table_levels = 4;

  constructor() {
    this.contact_id = null;
    this.header_location = "";
    this.header_date = null;
    this.show_info_employee = true;
    this.show_info_project = true;
    this.show_info_offer = true;
    this.show_info_customer = true;
    this.isOriginalApparence = true;
    this.displayQuotation = true;
    this.showDetailQuotationInRecap = false;
    this.pdfModel = "MODEL_1";
    this.logoSize = "80";
    this.recapAmountPageBreak = false;
    this.recapTablePageBreak = false;
    this.detailledQuotationPageBreak = false;
    this.outroPageBreak = false;
    this.closingPageBreak = false;
    this.displaySignature = false;
    this.displayQuotationAsAnnex = false;
    this.isShowsArticleNumber = false;
    this.isShowsDiscountValue = false;
    this.isShowsSellingPriceUnit = true;
    this.isShowsSellingPriceTotal = true;
    this.isShowsQuantity = true;
    this.isShowsArticlePrices = true;
    this.showRecap = true;
    this.showRecapFirst = false;
    this.title = "";
    this.reference = "";
    this.headerHTML = "";
    this.outro_offerHTML = "";
    this.closing_textHTML = "";
    this.recap_table_levels = 4;
  }

  public static createInstance(jsonData: any): OfferPdfConfig {
    const instance = new OfferPdfConfig();

    for (const key in jsonData) {
      if (jsonData[key] !== null && jsonData[key] !== undefined) {
        instance[key] = jsonData[key];
      }
    }

    if (instance.header_date) {
      instance.header_date = new Date(instance.header_date);
    }
    instance.apparence = DocumentEvaCompanyApparence.createInstance(jsonData.apparence || {});
    instance.annexes = (jsonData.annexes || []).map((a: any) => HTMLEntry.createInstance(a));
    return instance;
  }
}
